import { render, staticRenderFns } from "./YueDongZhongHua.vue?vue&type=template&id=65876efb&"
import script from "./YueDongZhongHua.vue?vue&type=script&lang=js&"
export * from "./YueDongZhongHua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports